import { AttendeeAndPresenterProvider } from '../context/AttendeeAndPresenterProvider';
import { TeamScore } from '../common';
import Controls from './Controls';
import QuestionComponent from './QuestionComponent';

const Presenter = ({ isReadOnly }) => {
  return (
    <AttendeeAndPresenterProvider isPresenterOrLeaderBoard>
      <div className="flex-center direction-column" style={{ padding: 50 }}>
        <TeamScore isPresenter />
        <QuestionComponent />
        {!isReadOnly && <Controls />}
      </div>
    </AttendeeAndPresenterProvider>
  );
};

export default Presenter;
